<template>
<draggable 
v-model="listdata"
:data_container_id="type"
class="list-group" 
:group="groupname" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
<LineItem :line="element" :type="type"></LineItem>

</template>




</draggable>
</template>

<script>
export default {

  name: 'SortableArray',
  props:["list","groupname","type","datacontainer"],
  data () {
    return {
      listdata:[],
    	drag:false,
    	remove_from_id:null,
    	removing_item_id:null,
    	add_to_id:null,
    	adding_item_id:null,
    }
  },
   computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  mounted()
  {
    this.listdata = this.list
  },
  watch:{
    list(newval)
    {
      this.listdata = newval
    }
  },
  methods:{
  	relocateItems()
  	{
  		let formdata = new FormData()  		  
  		formdata.append("add_to_id",this.add_to_id)
  		formdata.append("adding_item_id",this.adding_item_id)
  		this.generalSubmission(formdata,"questionlists/"+this.type+"/relocate",this.afterChange)
  	},
  	reorderItems()
  	{
  		let formdata = new FormData()  		  
  		formdata.append("add_to_id",this.add_to_id)
  		formdata.append("adding_item_id",this.adding_item_id)
  		this.generalSubmission(formdata,"questionlists/"+this.type+"/relocate",this.afterChange)
  	},
  	async change(event)
  	{
      
  		if(event.removed)
  		{
  			
  		}
  		if(event.added)
  		{
  			this.add_to_id  = await  this.datacontainer.id
			  this.adding_item_id  = await  event.added.element.id
			  await this.relocateItems()  			
  		}
  		
  	},
  	afterChange(response)
  	{
  		console.log("response");
  		console.log(response.data);
  		this.add_to_id = null
  		this.adding_item_id = null
  	},
  	end(event)
  	{		
  		var elements = Array.from(event.item.attributes)

  		let formdata = new FormData()  		  
  		formdata.append("items",JSON.stringify(this.listdata))
      console.log("list")
      console.log(this.listdata)
  		//formdata.append("reorder_container_id",this.datacontainer.id)
  		this.generalSubmission(formdata,"questionlists/"+elements[2].value+"/reorder",this.afterChange)

  		this.drag = false
  	},
  	start(event)
  	{
  		/*
  		console.log("start");
  		console.log(event);
  		console.log(this.datacontainer);*/

  		this.drag = true
  	},
  }
}
</script>

<style lang="css" scoped>
</style>